import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd';
import { Subscription } from 'rxjs';
import { HeadersModel, IHeadersTable, TypeCell } from 'src/app/models/headersTable.model';
import { TableModel } from 'src/app/models/table.model';
import { AccessService } from 'src/app/services/access.services';
import { ApiService } from 'src/app/services/api.service';
import { CountriesService } from 'src/app/services/countries.service';
import { FraudService } from 'src/app/services/frauds.service';

@Component({
  selector: 'app-anti-pishing',
  templateUrl: './anti-pishing.component.html',
  styleUrls: ['./anti-pishing.component.scss']
})
export class AntiPishingComponent implements OnInit, OnDestroy {

  public filters: any = this.getFilters();
  public isVisible: boolean = false;
  public titlePage: string = 'Actividades > Cash In > Anti-pishing';
  public fraudId: number = 0;
  protected otpControl = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
  titleAccion: string = '';
  valueStatus: number = 0;
  countries: any[] = [];
  public isOkLoading: boolean = false;
  public frauds: [] = [];
  public dataTable: TableModel<any> = new TableModel([], this.headersTable, { total: 0, currentPage: 1, pageSize: 10, lastPage: 1 });
  public pagination: any;
  public pageSize = 10;
  protected page = 1;
  public isLoading = false;
  public subFrauds: Subscription;
  fraudChildren: [] = [];
  protected filterTable = {
    page: 1,
    pageSize: this.pageSize,
    countryCode: null,
    name: null,
    merchantCode: null
  }
  public ud: any;

  constructor(
    private api: ApiService,
    private router: Router,
    private countriesService: CountriesService,
    private fraudService: FraudService,
    private nzModalService: NzModalService,
    private accessService: AccessService) {
    this.countriesService.countries$.subscribe(countries => {
      if (countries.length === 0) {
        this.countriesService.getCountries();
      } else {
        this.countries = countries;
      }
    })
  }

  ngOnInit(): void {
    this.getFrauds();
    this.getFraudStatus();
  }
  async getFilters() {

    let data = {
      service: 'merchants'
    }

    let dataMerchant = []
    await this.api.api(data).toPromise().then((result: any) => {
      result.forEach(element => {
        dataMerchant.push({
          name: element.BussinesName,
          value: element.MerchantCode,
        });
      });
    }).catch(error => {
      if (error.status === 401) {
        sessionStorage.setItem('ud', '');
        this.router.navigate(['/']);
      }
    });

    return [
      {
        'name': 'Fecha',
        'key': 'date',
        'type': 'date'
      },
      {
        'name': 'Comercio',
        'key': 'merchantCode',
        'type': 'select',
        'data': dataMerchant
      },
      {
        'name': 'N° Operación',
        'key': 'publicId',
        'type': 'text'
      },
      {
        'name': 'País',
        'key': 'countryCode',
        'type': 'select',
        'data': this.countries
      },
      {
        'name': 'N° Documento',
        'key': 'docNumber',
        'type': 'text'
      },
    ]
  }

  changeDataTable(data) {
    this.filterTable = { ...this.filterTable, ...data, page: 1 };
    this.page = 1;
    this.searchData(this.page);
  }

  showModal(fraudId: any, statusKey: string, statusId: number) {

    const state = this.getStatusName(statusKey);

    this.fraudId = fraudId;
    this.titleAccion = state;
    this.valueStatus = statusId;
    this.isVisible = true;
  }

  handleCancel() {
    this.isVisible = false;
  }

  confirmModal() {
    const userData = sessionStorage.getItem('ud');
    this.ud = userData ? JSON.parse(userData) : null;
    const id = this.ud?.userDetails?.id;
    this.accessService.validateAuthToken(this.otpControl.value, id).subscribe(() => {
      this.updatedFraudStatus(this.fraudId, this.valueStatus);
      this.isVisible = false;
    }, () => {
      this.otpControl.reset();
      this.error('Token incorreto');
    })
  }

  error(error): void {
    this.nzModalService.error({ nzTitle: 'Mensaje de error', nzContent: error });
  }


  updatedFraudStatus(idFraud: number, status: number) {
    this.isVisible = true;
    this.fraudService.updateStatusFraud(idFraud, status).subscribe(() => {
      this.isVisible = false;
      this.nzModalService.success({ nzTitle: "Se cambio de estado" });
      this.getFrauds();
    });
  }

  ngOnDestroy() {
    this.subFrauds.unsubscribe()
  }

  get headersTable(): HeadersModel[] {
    const headers: IHeadersTable[] = [
      {
        label: 'Operación',
        key: 'fraudId',
      },
      {
        label: 'Public ID',
        key: 'publicId'
      },
      {
        label: 'Comprador',
        key: 'shopper',
      },
      {
        label: 'Pagador',
        key: 'payer',
      },
      {
        label: 'Monto Transacción',
        key: 'amount',
      },
      {
        label: 'Motivos de anti-pishing',
        key: 'ruleTitle',
      },
      {
        label: 'Estado',
        key: 'status',
        type: TypeCell.status
      },
      {
        label: 'Nivel de riesgo',
        key: 'riskLevel',
        type: TypeCell.status
      },
      {
        label: 'Action',
        key: 'fraudId',
        labelCol: 'Editar',
        type: TypeCell.linkInternal,
        path: '/settings/merchants/edit/',
      }
    ]

    return headers.map((header) => new HeadersModel(header));
  }

  tableEvent(event) {
  }

  searchData(index) {
    this.page = index;
    this.filterTable = { ...this.filterTable, page: index };
    this.isLoading = true;
    this.fraudService.getFrauds(this.filterTable).subscribe((res: any) => {
      this.frauds = res.data;

      const raw = res.metadata.pagination ?? res.metadata;

      const rawPagination = {
        total:  Number(raw.total ?? raw.totalItems),
        currentPage: Number(raw.currentPage),
        pageSize: Number(raw.pageSize),
        lastPage: Number(raw.lastPage ?? raw.totalPages)
      };

      this.dataTable = new TableModel(this.frauds, this.headersTable, rawPagination);
      this.isLoading = false;
    });
  }

  getFrauds() {
    this.isLoading = true;
    this.subFrauds = this.fraudService.getFrauds({ page: 1, pageSize: this.pageSize }).subscribe((res: any) => {
      this.frauds = res.data;

      const raw = res.metadata.pagination ?? res.metadata;

      const rawPagination = {
        total:  Number(raw.total ?? raw.totalItems),
        currentPage: Number(raw.currentPage),
        pageSize: Number(raw.pageSize),
        lastPage: Number(raw.lastPage ?? raw.totalPages)
      };

      this.pagination = rawPagination;

      this.dataTable = new TableModel(
        this.frauds,
        this.headersTable,
        rawPagination
      );
      this.isLoading = false;
    });
  }

  getStatusPishing(status: { code: number; label: string }) {
    const colorMap = {
      1: '#4CAF50',
      2: '#FF9100',
      3: '#003F93',
    };

    return {
      color: colorMap[status.code] ?? 'gray',
      label: status.label ?? 'Sin estado'
    };
  }

  getStatusNivelPishing(value: { code: number; label: string }) {
    const status = {
      1: 'green',
      2: 'orange',
      3: 'red'
    }

    return {
      color: status[value.code] ?? 'gray',
      label: value.label ?? 'Sin estado'
    };
  }

  getFraudStatus() {
    this.fraudService.getStatusFraud().subscribe((data: any) => {
      const fraudData = data?.data;
  
      if (Array.isArray(fraudData)) {
        this.fraudChildren = fraudData.reduce((acc: any, item: any) => {
          const children = (item.childs || []).map((child: any) => ({
            termId: child.termId,
            key: child.key,
            name: this.getStatusName(child.key)
          }));
          return acc.concat(children);
        }, []);
      }
    });
  }
  
  getStatusName(key: string): string {
    switch (key) {
      case "AUTHORIZED":
        return 'Autorizar';
      case "REVIEW":
        return 'Mantener en observación';
      case "FRAUD":
        return 'Alerta de fraude';
      default:
        return 'Desconocido';
    }
  }
  
}